import React from 'react'

const SmallButtonList = props => {
  return (
    <div className="buttons">
      {props.buttons.map(data => {
        return <SmallButton key={data.text} text={data.text} onClick={data.onClick} />
      })}
    </div>
  )
}

const SmallButton = props => {
  return <button className="button is-small" onClick={props.onClick}>{props.text}</button>
}

export default SmallButtonList



// WEBPACK FOOTER //
// ./src/components/generic/SmallButtonList.js